<script setup>
import { ref } from 'vue'

const isSend = ref(false)

const sendComment = () => {
    isSend.value = true
}

</script>

<style lang="scss">
.notify {
    text-align: center;
}
</style>

<template>
    <div>
        <div class="comments__moder" v-if="isSend">
            Ваш комментарий отправлен на модерацию
        </div>
        <form action="" v-else class="comments__form" @submit.prevent="sendComment">
            <v-input type="text" label="Текст" required />
            <button class="btn btn--full" type="submit">Отправить</button>
        </form>
    </div>
</template>